import { useCallback } from "react";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import * as Composition from "./composition";
import * as Repository from "../../../repository";

import type * as Shared from "../../../../_shared";

type Props = {
	viewModel: Shared.Model.Type.FormModel["ViewModel"];
	onSuccessCallback: () => void;
};

export const useVoucherUpdate = ({ viewModel, onSuccessCallback }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { onVoucherUpdate: _onVoucherUpdate } = Repository.Mutation.UseCase.useVoucherUpdateMutation();
	/**
	 * 宿泊券の更新
	 */
	const onVoucherUpdate = useCallback(() => {
		showLoadingScreenCallback();

		const input = Composition.viewModelToInputConverter({ viewModel });
		_onVoucherUpdate(input)
			.then(({ errors }) => {
				if (!errors) {
					notifyUserEventInfo({
						variant: "default",
						title: "宿泊券を更新しました",
					});
					onSuccessCallback();
				}
			})
			.finally(() => {
				hideLoadingScreenCallback();
			});
	}, [_onVoucherUpdate, hideLoadingScreenCallback, onSuccessCallback, showLoadingScreenCallback, viewModel]);

	return {
		onVoucherUpdate,
	};
};
